// FILE: src/app/(portal)/error.tsx
// VERSION: 1.0.0
// START_MODULE_CONTRACT:
// PURPOSE: Глобальный Error Boundary для публичного портала. Отлавливает ошибки рендера в ~50 sub-routes.
// SCOPE: (portal) — тёмная тема, зелёные акценты
// INPUT: Error объект из Next.js Error Boundary
// OUTPUT: UI с предложением повторить попытку (портальный стиль)
// KEYWORDS: DOMAIN(ErrorBoundary); CONCEPT(ErrorHandling, Portal, DarkTheme)
// LINKS: USES_API(Next.js ErrorBoundary); USES_API(lucide-react ShieldAlert)
// END_MODULE_CONTRACT

'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { Button } from '@oxpa/shared/ui/button';
import { ShieldAlert } from 'lucide-react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[Portal Error]', error);
  }, [error]);

  return (
    <div className="flex-1 flex items-center justify-center py-20">
      <div className="text-center max-w-md px-6">
        <div className="w-16 h-16 border border-[hsl(var(--portal-danger))]/30 bg-[hsl(var(--portal-danger))]/10 flex items-center justify-center mx-auto mb-8">
          <ShieldAlert className="w-8 h-8 text-[hsl(var(--portal-danger))]" />
        </div>
        <h1 className="text-3xl font-bold uppercase tracking-tight mb-4 text-[hsl(var(--portal-text))]">
          Что-то пошло не так
        </h1>
        <p className="text-[hsl(var(--portal-text-secondary))] font-sans text-lg mb-8 leading-relaxed">
          Произошла ошибка при загрузке страницы. Попробуйте обновить страницу или вернуться на главную.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            onClick={() => reset()}
            className="bg-[hsl(var(--portal-accent))] hover:bg-[hsl(var(--portal-accent))] text-[hsl(var(--portal-text))] h-12 px-8 uppercase tracking-widest text-xs font-bold rounded-none"
          >
            Попробовать снова
          </Button>
          <Link href="/">
            <Button
              variant="outline"
              className="rounded-none border-[hsl(var(--portal-border-hover))] text-[hsl(var(--portal-text))] hover:bg-[hsl(var(--portal-surface-2))] hover:text-[hsl(var(--portal-text))] h-12 px-8 uppercase tracking-widest text-xs font-bold"
            >
              На главную
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
